module.exports = __webpack_public_path__ + "img/uploaded.37b6bc65.png";